export default __webpack_public_path__ + "static/media/oneid-small@2x.8cbd7029.png";